import { render, staticRenderFns } from "./Tagify.vue?vue&type=template&id=36c6e3f7"
import script from "./Tagify.vue?vue&type=script&lang=js"
export * from "./Tagify.vue?vue&type=script&lang=js"
import style0 from "./Tagify.vue?vue&type=style&index=0&id=36c6e3f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports